import { Model } from 'caldera-immutable-model';
import User from '../../models/User';

import type { UserObject } from './types';

type UserConvertible = UserObject | User;

export default class UserState extends Model {

  _user: ?User;

  constructor(data: any) {
    super(data);
    const user = this.get('user');
    this._user = user ? new User(user) : null;
  }

  // Current user data

  get user(): ?User {
    return this._user;
  }

  setUser(user: ?UserConvertible): UserState {
    return this.set('user', user);
  }

  removeUser(): UserState {
    return this.setUser(null);
  }

  get isAddingUser(): boolean {
    return !!this.get('isAddingUser');
  }

  setIsAddingUser(isAddingUser: boolean): UserState {
    return this.set('isAddingUser', isAddingUser);
  }

  // Logged in

  get isLoggedIn(): boolean {
    return !!this.get('isLoggedIn');
  }

  setIsLoggedIn(isLoggedIn: boolean): UserState {
    return this.set('isLoggedIn', isLoggedIn);
  }

  get isLoggingIn(): boolean {
    return !!this.get('isLoggingIn');
  }

  setIsLoggingIn(isLoggingIn: boolean): UserState {
    return this.set('isLoggingIn', isLoggingIn);
  }

  // Other flags

  get isSettingUpAuth(): boolean {
    return !!this.get('isSettingUpAuth');
  }

  setIsSettingUpAuth(isSettingUpAuth: boolean): UserState {
    return this.set('isSettingUpAuth', isSettingUpAuth);
  }

  get isUpdatingUser(): boolean {
    return !!this.get('isUpdatingUser');
  }

  setIsUpdatingUser(isUpdatingUser: boolean): UserState {
    return this.set('isUpdatingUser', isUpdatingUser);
  }

  get showIncorrectPasswordError(): boolean {
    return !!this.get('showIncorrectPasswordError');
  }

  setShowIncorrectPasswordError(show: boolean): UserState {
    return this.set('showIncorrectPasswordError', show);
  }

  get showTouchIdNotSupportedError(): boolean {
    return !!this.get('showTouchIdNotSupportedError');
  }

  setShowTouchIdNotSupportedError(show: boolean): UserState {
    return this.set('showTouchIdNotSupportedError', show);
  }

  get showInvalidEmailError(): boolean {
    return !!this.get('showInvalidEmailError');
  }

  setShowInvalidEmailError(show: boolean): UserState {
    return this.set('showInvalidEmailError', show);
  }

  get showWeakPasswordError(): boolean {
    return !!this.get('showWeakPasswordError');
  }

  setShowWeakPasswordError(show: boolean): UserState {
    return this.set('showWeakPasswordError', show);
  }

  get showUnavailableEmailError(): boolean {
    return !!this.get('showUnavailableEmailError');
  }

  setShowUnavailableEmailError(show: boolean): UserState {
    return this.set('showUnavailableEmailError', show);
 }
  get isCreatingCustomer(): boolean {
    return !!this.get('isCreatingCustomer');
  }

  setIsCreatingCustomer(isCreatingCustomer: boolean): UserState {
    return this.set('isCreatingCustomer', isCreatingCustomer);
  }

  get isCreatingSubscription(): boolean {
    return !!this.get('isCreatingSubscription');
  }

  setIsCreatingSubscription(isCreatingSubscription: boolean): UserState {
    return this.set('isCreatingSubscription', isCreatingSubscription);
  }

  get showIncorrectCouponError(): boolean {
    return !!this.get('showIncorrectCouponError');
  }

  setShowIncorrectCouponError(show: boolean): UserState {
    return this.set('showIncorrectCouponError', show);
  }

  get showCouponSuccess(): boolean {
    return !!this.get('showCouponSuccess');
  }

  setShowCouponSuccess(show: boolean): UserState {
    return this.set('showCouponSuccess', show);
  }

  get isFetchingCoupon(): boolean {
    return !!this.get('isFetchingCoupon');
  }

  setIsFetchingCoupon(isFetchingCoupon: boolean): UserState {
    return this.set('isFetchingCoupon', isFetchingCoupon);
  }

}



// WEBPACK FOOTER //
// ./src/redux/user/UserState.js